import { useState } from "react";
import "./editorialForms.css";

const categories = [
  { id: "skincare", name: "Skincare" },
  { id: "makeup", name: "Maquiagem" },
  { id: "haircare", name: "Cabelo" },
  { id: "nails", name: "Unhas" },
  { id: "fragrance", name: "Perfume" },
  { id: "tutorial", name: "Tutorial" },
];

const skinTypes = [
  "Normal",
  "Oleosa",
  "Seca",
  "Mista",
  "Sensível",
  "Acneica",
  "Madura",
];

const difficulties = [
  { id: "beginner", name: "Iniciante" },
  { id: "intermediate", name: "Intermediário" },
  { id: "advanced", name: "Avançado" },
];

export default function BeautyForm({ data, onChange }) {
  const [productInput, setProductInput] = useState({
    name: "",
    brand: "",
    price: "",
    link: "",
  });
  const [stepInput, setStepInput] = useState("");

  const handleAddProduct = () => {
    if (productInput.name.trim()) {
      onChange({
        ...data,
        products: [
          ...(data?.products || []),
          {
            name: productInput.name.trim(),
            brand: productInput.brand.trim(),
            price: parseFloat(productInput.price) || 0,
            link: productInput.link.trim(),
            rating: 0,
          },
        ],
      });
      setProductInput({ name: "", brand: "", price: "", link: "" });
    }
  };

  const handleRemoveProduct = (index) => {
    onChange({
      ...data,
      products: (data?.products || []).filter((_, i) => i !== index),
    });
  };

  const handleAddStep = () => {
    if (stepInput.trim()) {
      const currentSteps = data?.steps || [];
      onChange({
        ...data,
        steps: [
          ...currentSteps,
          {
            step: currentSteps.length + 1,
            description: stepInput.trim(),
          },
        ],
      });
      setStepInput("");
    }
  };

  const handleRemoveStep = (index) => {
    const newSteps = (data?.steps || [])
      .filter((_, i) => i !== index)
      .map((step, i) => ({ ...step, step: i + 1 }));
    onChange({ ...data, steps: newSteps });
  };

  const handleToggleSkinType = (type) => {
    const current = data?.skinType || [];
    if (current.includes(type)) {
      onChange({
        ...data,
        skinType: current.filter((t) => t !== type),
      });
    } else {
      onChange({
        ...data,
        skinType: [...current, type],
      });
    }
  };

  return (
    <div className="editorial_form beauty_form">
      <div className="editorial_form_section">
        <label>
          Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Rotina de Skincare Noturna, Make Natural..."
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva a rotina, os benefícios, para quem é indicada..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Dificuldade</label>
          <select
            value={data?.difficulty || ""}
            onChange={(e) => onChange({ ...data, difficulty: e.target.value })}
          >
            <option value="">Selecione</option>
            {difficulties.map((diff) => (
              <option key={diff.id} value={diff.id}>
                {diff.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Duração (min)</label>
          <input
            type="number"
            placeholder="15"
            value={data?.duration || ""}
            onChange={(e) =>
              onChange({ ...data, duration: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>
      </div>

      {(data?.category === "skincare" || !data?.category) && (
        <div className="editorial_form_section">
          <label>Tipo de Pele Indicado</label>
          <div className="genre_chips">
            {skinTypes.map((type) => (
              <span
                key={type}
                className={`genre_chip ${
                  (data?.skinType || []).includes(type) ? "selected" : ""
                }`}
                onClick={() => handleToggleSkinType(type)}
              >
                {type}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="editorial_form_section">
        <label>
          Produtos Utilizados
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddProduct}
          >
            + Adicionar
          </button>
        </label>
        <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
          <input
            type="text"
            placeholder="Produto"
            value={productInput.name}
            onChange={(e) =>
              setProductInput({ ...productInput, name: e.target.value })
            }
            style={{ flex: 2 }}
          />
          <input
            type="text"
            placeholder="Marca"
            value={productInput.brand}
            onChange={(e) =>
              setProductInput({ ...productInput, brand: e.target.value })
            }
            style={{ flex: 1 }}
          />
          <input
            type="number"
            placeholder="Preço"
            value={productInput.price}
            onChange={(e) =>
              setProductInput({ ...productInput, price: e.target.value })
            }
            min="0"
            style={{ flex: 1 }}
          />
        </div>
        <input
          type="url"
          placeholder="Link para compra (opcional)"
          value={productInput.link}
          onChange={(e) =>
            setProductInput({ ...productInput, link: e.target.value })
          }
          style={{ marginBottom: "8px" }}
        />
        {(data?.products || []).length > 0 && (
          <div style={{ marginTop: "8px" }}>
            {data.products.map((product, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  background: "var(--bg-third)",
                  borderRadius: "6px",
                  marginBottom: "4px",
                }}
              >
                <span>
                  <strong>{product.name}</strong>
                  {product.brand && ` - ${product.brand}`}
                  {product.price > 0 && ` (R$${product.price})`}
                </span>
                <button
                  type="button"
                  className="remove_variant_btn"
                  onClick={() => handleRemoveProduct(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="editorial_form_section">
        <label>
          Passo a Passo
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddStep}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Descreva o passo..."
          value={stepInput}
          onChange={(e) => setStepInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddStep()}
        />
        {(data?.steps || []).length > 0 && (
          <div style={{ marginTop: "8px" }}>
            {data.steps.map((step, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  padding: "8px",
                  background: "var(--bg-third)",
                  borderRadius: "6px",
                  marginBottom: "4px",
                }}
              >
                <span
                  style={{
                    background: "var(--blue-color)",
                    color: "white",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    fontSize: "12px",
                  }}
                >
                  {step.step}
                </span>
                <span style={{ flex: 1 }}>{step.description}</span>
                <button
                  type="button"
                  className="remove_variant_btn"
                  onClick={() => handleRemoveStep(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="editorial_form_section">
        <label>Resultados Esperados</label>
        <textarea
          placeholder="Descreva os resultados que podem ser esperados..."
          value={data?.results || ""}
          onChange={(e) => onChange({ ...data, results: e.target.value })}
          rows={2}
        />
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
        </svg>
        <span>
          Fotos de antes e depois aumentam o engajamento em até 50%!
        </span>
      </div>
    </div>
  );
}
